import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './fonts/fonts.css';
import './styles/index.css';
import App from './App';
import ImModuleStyle from '../src/components/im/styles/im.module.css';

import reportWebVitals from './reportWebVitals';

document.addEventListener('DOMContentLoaded', function () {
  let pathname = window.location.pathname;
  let title = pathname.indexOf("/im") !== -1 ? "Inventory Management" :
    pathname.indexOf("/fc") !== -1 ? "Forecasting" :
      pathname.indexOf("/pm") !== -1 ? "Project Management" :
        pathname.indexOf("/qm") !== -1 ? "Quality Management" :
          pathname.indexOf("/scm") !== -1 ? "Supply Chain Management" :
            "";
  document.title = title;
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <a className="skip-to-main-content-link ng-scope" href="#" onClick={(e) => {
      e.preventDefault();
      // document.querySelector(`.${ImModuleStyle['simulation']}.${ImModuleStyle['container']}`).scrollIntoView({ behavior: 'smooth' });
      // document.querySelector(`.${ImModuleStyle['simulation']}.${ImModuleStyle['container']} .${ImModuleStyle['introtext']} .${ImModuleStyle['heading']}`).focus();
      document.querySelector(`.app>div`).scrollIntoView({ behavior: 'smooth' });
      document.querySelector(`.app>div h2`).setAttribute("tabindex","-1");
      document.querySelector(`.app>div h2`).focus();
      e.target.blur();
    }} >Skip to main content</a>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
